import { useState } from "react";
import "./style.scss";

// Rating is always finalized through RatingCommentModal (comment optional) -
// clicking a star here never submits by itself, it only reports the chosen
// star count up via onRate.
const StarRating = ({ rating = 0, onRate }) => {
  const [hovered, setHovered] = useState(0);

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map(star => (
        <span
          key={star}
          className={`star-rating-star ${
            star <= (hovered || rating) ? "filled" : ""
          }`}
          onClick={e => {
            e.stopPropagation();
            onRate(star);
          }}
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          role="button"
          tabIndex={0}
          aria-label={`Rate ${star} star${star > 1 ? "s" : ""}`}>
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
